import FileUploadModule from "./fileUploadModule";

export default FileUploadModule;